var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 58,
    viewBox: "0 0 170 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0209 29L14.8152 33.8224C15.5256 38.1356 18.9062 41.5161 23.2193 42.2265L28.0417 43.0209L23.2193 43.8152C18.9062 44.5256 15.5256 47.9062 14.8152 52.2193L14.0209 57.0417L13.2265 52.2193C12.5161 47.9062 9.13556 44.5256 4.8224 43.8152L0 43.0209L4.8224 42.2265C9.13556 41.5161 12.5161 38.1356 13.2265 33.8224L14.0209 29Z",
    fill: "url(#paint0_linear_99_371)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.021 29L155.815 33.8224C156.526 38.1356 159.906 41.5161 164.219 42.2265L169.042 43.0209L164.219 43.8152C159.906 44.5256 156.526 47.9062 155.815 52.2193L155.021 57.0417L154.227 52.2193C153.516 47.9062 150.136 44.5256 145.822 43.8152L141 43.0209L145.822 42.2265C150.136 41.5161 153.516 38.1356 154.227 33.8224L155.021 29Z",
    fill: "url(#paint1_linear_99_371)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.059 0L84.2454 7.20249C85.3065 13.6444 90.3555 18.6934 96.7974 19.7545L104 20.9409L96.7974 22.1272C90.3555 23.1883 85.3065 28.2373 84.2454 34.6792L83.059 41.8817L81.8727 34.6792C80.8116 28.2373 75.7626 23.1883 69.3207 22.1272L62.1182 20.9409L69.3207 19.7545C75.7626 18.6934 80.8116 13.6444 81.8727 7.20249L83.059 0Z",
    fill: "#FBC418"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_371",
    x1: 24.9432,
    y1: 29,
    x2: 2.4719,
    y2: 33.7325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_371",
    x1: 165.943,
    y1: 29,
    x2: 143.472,
    y2: 33.7325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A01"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLights);
export default __webpack_public_path__ + "static/media/lights.62560d38928759720f45a90872e1102a.svg";
export { ForwardRef as ReactComponent };